'use strict'

let watermark = {}

let setWatermark = (str,height,width,waterMarkHeight) => {
  let id = '1.23452384164.123412999'

  if (document.getElementById(id) !== null) {
    // document.body.removeChild(document.getElementById(id))
    document.getElementById('org_tree_imgs').childNodes[0].removeChild(document.getElementById(id))
  }

  let can = document.createElement('canvas')
  can.width = (parseInt(str.length, 10))*28
  can.height = waterMarkHeight

  let cans = can.getContext('2d')
  cans.rotate(45 * Math.PI / 180)
  cans.font = '50px "Avenir", Helvetica, Arial, sans-serif'
  cans.fillStyle = 'rgba(242, 242, 242, 2)'
  cans.textAlign = 'left'
  cans.textBaseline = 'Middle'
  cans.fillText(str, 20, 10)

  let div = document.createElement('div')
  document.getElementById('org_tree_imgs').childNodes[0].appendChild(div)
  div.id = id
  div.style.pointerEvents = 'none'
  //水印的位置以及水印的宽高
  div.style.top = height/2 - waterMarkHeight/2 +'px'
  div.style.left = '0px'
  div.style.position = 'absolute'
  div.style.zIndex = '100000'
  div.style.width = '300%'
  div.style.height = waterMarkHeight +'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  return id
}

// 该方法只允许调用一次
watermark.set = (str,height,width,waterMarkHeight) => {
  let id = setWatermark(str,height,width,waterMarkHeight)
}

export default watermark
